module.exports = __webpack_public_path__ + "img/System_incp.423b099d.svg";